import { useId } from 'react';

export const HubspotIcon = (props: React.ComponentPropsWithoutRef<'svg'>) => {
  const id = useId();
  const mask = `${id}-mask`;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" {...props}>
      <mask id={mask} maskUnits="userSpaceOnUse" x="3" y="2" width="14" height="16" style={{ maskType: 'luminance' }}>
        <path d="M16.3059 2.5H3.69531V17.5H16.3059V2.5Z" fill="white" />
      </mask>
      <g mask={`url(#${mask})`}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.3415 6.36542V7.90596H13.339C14.7501 8.12153 15.8773 9.1807 16.1664 10.5627C16.4556 11.9447 15.8459 13.3589 14.6371 14.11C13.4283 14.8611 11.8747 14.7911 10.74 13.9345L9.47129 15.1885C9.50411 15.2903 9.52159 15.3962 9.52309 15.503C9.52309 16.1108 9.02466 16.6034 8.40981 16.6034C7.79496 16.6034 7.29652 16.1108 7.29652 15.503C7.29652 14.8953 7.79496 14.4026 8.40981 14.4026C8.51785 14.4042 8.62505 14.4214 8.72801 14.4538L10.0105 13.1862C9.20191 12.0492 9.18102 10.5385 9.95786 9.38009L5.7436 6.13734C5.17814 6.45814 4.46219 6.33977 4.03315 5.85454C3.6041 5.36932 3.58128 4.6522 3.97863 4.14128C4.37598 3.63036 5.08298 3.46775 5.66772 3.7528C6.25245 4.03784 6.55228 4.69125 6.38404 5.31386L10.6704 8.61341C11.138 8.24175 11.6966 7.99881 12.2897 7.90916V6.36542C11.8686 6.17103 11.5987 5.75402 11.5966 5.29465V5.25863C11.5984 4.60391 12.1349 4.07358 12.7974 4.07182H12.8338C13.4962 4.07358 14.0327 4.60391 14.0345 5.25863V5.29465C14.0325 5.75402 13.7626 6.17103 13.3415 6.36542ZM11.0622 11.2434C11.0606 12.2012 11.8445 12.9791 12.8135 12.9814L12.8176 12.9822C13.787 12.9822 14.5729 12.2053 14.5729 11.2471C14.5734 10.2893 13.7885 9.51237 12.8195 9.51134C11.8505 9.5103 11.0639 10.2856 11.0622 11.2434Z"
          fill="#FF4800"
        />
      </g>
    </svg>
  );
};
